import { postJson } from "./common"

export async function attemptLogin({ userEmail, userPassword }) {
  await postJson('/user/login', { userEmail, userPassword });
}